import React from 'react';
import { OpenHours } from 'types/FarmData';
import { RawOpenHoursDay } from 'utils/timeHelpers';
import { WorkingTimeWrapper } from './style';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

type DayHours = OpenHours | RawOpenHoursDay | undefined;

interface DayTimeProps {
  dayTime: DayHours;
}

dayjs.extend(customParseFormat);

const formatDate = (input: string): string => {
  // Already looks like "HH:mm"?
  if (/^\d{1,2}:\d{2}$/.test(input)) return input;

  // Try to parse ISO or other formats
  const parsed = dayjs(input);
  return parsed.isValid() ? parsed.format('HH:mm') : input;
};

const DayTime: React.FC<DayTimeProps> = ({ dayTime }) => {
  const from = dayTime?.no ? formatDate(dayTime.no) : null;
  const to = dayTime?.lidz ? formatDate(dayTime.lidz) : null;

  return (
    <span className="day-time">{from && to ? `${from} - ${to}` : '-'}</span>
  );
};

interface WorkingTimeProps {
  daysOfWeek: string[];
  workingTime: DayHours[];
  workingTimeTitle?: string;
}

const WorkingTime: React.FC<WorkingTimeProps> = ({
  daysOfWeek,
  workingTime,
  workingTimeTitle,
}) => (
  <WorkingTimeWrapper>
    {workingTimeTitle && (
      <p className="working-time-title">{workingTimeTitle}</p>
    )}

    <div className="working-time">
      {daysOfWeek.map((day, index) => (
        <div key={index} className="day-time-row">
          <span className="day-name">{day}</span>
          <DayTime dayTime={workingTime[index]} />
        </div>
      ))}
    </div>
  </WorkingTimeWrapper>
);

export default WorkingTime;
